import styled from '@emotion/styled';
import { useListingContext } from '~/editor/plugin/ListingPlugin';
import MicrositeSection from '~/components/MicrositeSection';

const Inner = styled.div`
	max-width: 64rem;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

const PriceRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: flex-end;
	gap: 1.5rem;
`;

const PriceTag = styled.div`
	background: white;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
	font-size: 2rem;
	padding: 1rem 2rem;
`;

const Stats = styled.div`
	display: flex;
	flex-wrap: wrap;
	background: white;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
`;

const Stat = styled.div`
	flex: 1;
	min-width: 140px;
	padding: 1rem 1.5rem;
	text-align: center;
	font-size: 1.5rem;
`;

const Heading = styled.h2`
	font-size: 1.5rem;
	text-transform: uppercase;
	margin: 0;
`;

const Body = styled.div`
	font-size: 1.25rem;
	line-height: 2.2rem;
`;

function formatLotSize(lotAcres?: number, lot?: number) {
	if (lotAcres) {
		return `${lotAcres.toFixed(2)} ac lot`;
	}
	if (lot) {
		return `${lot.toLocaleString()} sf lot`;
	}
	return null;
}

export default function ListingBlockBeta() {
	const listing = useListingContext();
	const lotSize = formatLotSize(listing.lot_acres, listing.lot);

	return (
		<MicrositeSection fill id="overview">
			<Inner>
				<PriceRow>
					{listing.price_formatted && <PriceTag>${listing.price_formatted}</PriceTag>}
					<Stats>
						{listing.beds != null && <Stat>{listing.beds} beds</Stat>}
						{listing.baths != null && <Stat>{listing.baths} baths</Stat>}
						{listing.sqft != null && <Stat>{listing.sqft.toLocaleString()} sqft</Stat>}
						{lotSize && <Stat>{lotSize}</Stat>}
					</Stats>
				</PriceRow>
				{listing.body && (
					<div>
						<Heading>Overview</Heading>
						<Body>{listing.body}</Body>
					</div>
				)}
			</Inner>
		</MicrositeSection>
	);
}
